import { ApiRequestFilters } from '../../../shared/types/api-request-filters';
import { AgentStatusEnum } from '../enums/agent-status.enum';
import { AgentTypeEnum } from '../enums/agent-type.enum';

/**
 * Agents filters
 */
export class AgentsFilters extends ApiRequestFilters {
	/**
	 * Countries id values
	 */
	countries?: number[];

	/**
	 * Status values
	 */
	statuses?: AgentStatusEnum[];

	/**
	 * Type values
	 */
	types?: AgentTypeEnum[];

	/**
	 * Category id values
	 */
	categories?: number[];

	/**
	 * Tag id values
	 */
	tags?: number[];
}
